<template>
    <div>
        <Row class="grid-header grid-row-group px-10 pt-10">
        <Col :span="showReturnQty ? 6 : 8">
            <div class="cell">{{ header }}</div>
        </Col>
        <Col :span="showReturnQty ? 4 : 5">
            <div class="cell text-right">{{ $t('WALLET_SYSTEM_CHARGE') }}</div>
        </Col>
        <Col :span="showReturnQty ? 5 : 6">
            <div class="cell text-right">{{ $t('WALLET_TRANSPORTER_CHARGE') }}</div>
        </Col>
        <Col :span="showReturnQty ? 4 : 5">
            <div class="cell text-right">{{ $t('WALLET_SHIPPER_CHARGE') }}</div>
        </Col>
        <Col v-if="showReturnQty" :span="5">
            <div class="cell text-right"> {{ $t('INDENT_RETURN_QUANTITY') }} <span class="hint-text">{{ $t('INDENT_PCS') }}</span></div>
        </Col>
        </Row>
        <div>
        <Collapse
            accordion
            v-model="activeId"
            disable="arrow"
            highlight="true"
            class="collapse-table bordered">
            <CollapseItem
              :name="index"
              v-for="(material, index) in materials"
              :key="index">
                <template slot="title">
                    <Row type="flex" class="grid-collapse grid-bordered p-0">
                    <Col :span="showReturnQty ? 6 : 8">
                        <div class="cell">
                            <i class="icon-collapse"></i>
                            <span v-if="material.delay_days || material.delay_days === 0">{{ material.delay_days }} Days</span>
                            <span v-else-if="material.material_code">{{ material.material_code }}</span>
                            <span v-else>{{ material.column_subtext}}</span>
                            <span class="icon-wrapper f-right">
                                <span class="position-relative">
                                    <svgicon
                                        v-if="(material.comments && material.comments.length) || material.epod_comment"
                                        name="icon-comment"
                                        class="text-grey-dark2"
                                        width="13"
                                        height="12"
                                    />
                                    <i v-if="(material.comments && material.comments.length) || material.epod_comment" class="icon-badge">
                                        {{ material.epod_comment ? ( material.comments.length + 1 ) : material.comments.length }}
                                    </i>
                                    <Tooltip class="item" effect="dark" placement="bottom" v-if="showIcon && mandatoryComment[material.id]">
                                        <div slot="content" class="tooltipcontent">
                                            {{ $t('PAY_COMMENT_ATTACHMENT_MANDATORY') }}
                                        </div>
                                        <span class="badge badge-bottom">
                                            <svgicon name="icon-warning-circle" width="12" height="12" :original="true" />
                                        </span>
                                    </Tooltip>
                                </span>
                            </span>
                        </div>
                    </Col>
                    <Col :span="showReturnQty ? 4 : 5">
                        <div class="cell text-right">{{ material.system_amount }}</div>
                    </Col>
                    <Col :span="showReturnQty ? 5 : 6">
                        <div class="cell text-right" :class="{ 'text-blue': material.transporter_amount !== material.system_amount}">
                            <span v-if="!isGenerated">{{ material.transporter_amount }}</span>
                            <Input
                                v-else
                                class="input-blank text-right bg-white"
                                size="xsmall"
                                min="0"
                                type="number"
                                v-model="material.transporter_amount"
                                @input="valuesChanged($event, material)">
                            </Input>
                        </div>
                    </Col>
                    <Col :span="showReturnQty ? 4 : 5">
                        <div class="cell text-right">
                            <span v-if="readOnly">{{ material.shipper_amount }}</span>
                            <Input
                                v-else
                                class="input-blank text-right bg-white"
                                size="xsmall"
                                min="0"
                                type="number"
                                v-model="material.shipper_amount"
                                @input="chargesChanged($event, index)">
                            </Input>
                        </div>
                    </Col>
                    <Col v-if="showReturnQty" :span="5">
                        <div class="cell text-right">
                            <Input
                                v-if="returnQtyEditable"
                                class="input-blank text-right bg-white"
                                size="xsmall"
                                min="0"
                                type="number"
                                placeholder="0"
                                v-model="material.return_quantity"
                                @input="$emit('updateCharge', { changedValue: material.return_quantity, materialIndex: index, field: 'return_quantity' })">
                            </Input>
                            <span v-else>{{ material.return_quantity || 0 }}</span>
                        </div>
                    </Col>
                    </Row>
                </template>
                <div class="collapse-inner">
                    <div class="comments-sec comment-box" v-if="material && material.epod_comment">
                        <h6 class="comments-title">
                            <span>{{ material.epod_comment.user_name }}</span>
                            <small>{{ material.epod_comment.created_at | moment("DD MMM YY | HH : mm A")}}</small>
                        </h6>
                        <p> {{ material.epod_comment.message }} </p>
                    </div>
                    <div class="drawer-collapse-scroll">
                        <div class="comments-sec"
                        v-for="(comment, index) in material.comments" :key="index">
                            <h6 class="comments-title">
                                <span class="badge bg-orange-light"> {{comment.party === 1 ? 'S' : 'T'}}</span>
                                <span>{{comment.user_name}}</span>
                                <small>{{comment.created_at | moment("DD MMM YY | HH : mm A")}}</small>
                            </h6>
                            <p v-html="getHighlightedMessage(comment.message)">
                            </p>
                            <IsolatedAttachments
                                :key="`comment-${comment.id}-attachments`"
                                :attachments="presentAttachments(comment)"
                                :disableUpload="true"
                                :showPreview="true"
                                :allowDelete="false"
                            />
                        </div>
                    </div>
                    <div class="position-relative z-index">
                        <div
                        :id="material.id"
                        class="content-editable mx-m10"
                        contenteditable="true"
                        badge="true"
                        placeholder="Add a comment"
                        @input="updateHTML($event, material)">
                        </div>
                        <IsolatedAttachments
                            :attachments="tempAttachments[material.id]"
                            :disableUpload="true"
                            :showPreview="true"
                            :allowDelete="true"
                            :sample="true"
                            @removeAttachments="removeAttachment"
                        />
                        <div class="collapse-bottom">
                            <div class="btn-group text-right">
                                <Upload
                                action
                                list-type="picture-card"
                                :auto-upload="false"
                                :show-file-list="false"
                                :on-change="addAttachment"
                                class="default-upload upload-plain is-badge">
                                    <svgicon
                                    name="icon-attachment-sm"
                                    class="text-red1 pointer"
                                    width="8"
                                    height="12"
                                    slot="default"/>
                                <div
                                    class="el-upload-list__item-slot"
                                    slot="file"
                                    slot-scope="{ file }">
                                    <img
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url"
                                    alt=""
                                    />
                                    <span class="el-upload-list__item-actions">
                                    <span class="badge" v-if="attachmentsCountBadge">
                                        + {{ attachmentsCountBadge }}
                                    </span>
                                    <span
                                        v-if="!disabled"
                                        class="el-upload-list__item-delete"
                                        @click="removeAttachment(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                    </span>
                                </div>
                                </Upload>
                                <a class="download-file" />
                                <Button
                                type="text"
                                size="mini"
                                class="button-link secondary ml-10"
                                @click="clearMessage(material.id)">{{ $t('CANCEL') }}</Button>
                                <Button type="text" :disabled="disableAdd(material.id)" size="mini" class="button-link" @click="addComment(material)">
                                  {{ $t('ADD') }}</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </CollapseItem>
        </Collapse>
        </div>
    </div>
</template>
<script>

import Vue from 'vue';
import debounce from 'debounce';
import IsolatedAttachments from './IsolatedAttachments';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import { attachmentParentType } from 'pando-constants';

export default{
    props: {
        materials: {
            type: Array,
            required: true,
        },
        header: {
            type: String,
            required: true,
        },
        isGenerated: {
            type: Boolean,
            required: false,
        },
        readOnly: {
            type: Boolean,
            default: true,
        },
        mandatoryComment: {
            type: Object,
            required: true,
        },
        showIcon: {
            type: Boolean,
            required: true,
        },
        showReturnQty: {
            type: Boolean,
            default: false,
        },
        returnQtyEditable: {
            type: Boolean,
            default: false,
        },
    },
    created() {
        this.setDefaults();
    },
    components: {
        IsolatedAttachments,
    },
    data() {
        return {
            activeId: null,
            tempComments: {},
            tempAttachments: {},
            temp: [],
            commentId: null,
            validComment: {},
        }
    },
    methods: {
        checkDoubleExtension(fileParts) {
        if (fileParts.length > 2) {
            const knownExtensions = ['jpeg', 'msg', 'jpg', 'png', 'svg', 'pdf', 'txt', 'doc', 'docx', 'docm', 'xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'csv', 'eml', 'zip', 'exe', 'com', 'bin', 'dll', 'html', 'htm', 'php', 'pl', 'vbs', 'bat', 'scr', 'pif', 'js'];

            for (let i = 1; i < fileParts.length - 1; i++) {
            if (knownExtensions.includes(fileParts[i].toLowerCase())) {
                return true;
            }
            }
        }
        return false;
        },
        roundOff(value) {
            let dataInput = Number(value);
            const decimalValues = (value.toString().split('.')[1] &&
                value.toString().split('.')[1].length) || 0;
            return (decimalValues > 2) ? dataInput.toFixed(2) : value;
        },
        chargesChanged: debounce(async function (value, index) {
            const amount = this.roundOff(value);
            this.materials[index].shipper_amount = amount;
            const data = {
                changedValue: amount,
                materialIndex: index,
            };
            this.$emit('updateCharge', data);
        }, 1000),
        disableAdd(id) {
            return !(this.validComment[id] || (this.tempAttachments[id] && this.tempAttachments[id].length !== 0));
        },
        valuesChanged: debounce(async function (value, material) {
            const materialIndex = this.materials.findIndex(_material => _material.id === material.id);
            const amount = this.roundOff(value);
            this.materials[materialIndex].transporter_amount = amount;
            this.$emit('updateValue', 'changedCharges', material.id, amount);
        }, 1000),
        presentAttachments(comment) {
            const attachments = comment.attachments || [];
            return attachments.map(attachment => ({
                id: attachment.id,
                url: attachment.metadata && attachment.metadata.location,
            }));
        },
        getHighlightedMessage(message) {
            const html = this.$sanitize(message);
            return html;
        },
        setDefaults(){
            this.materials.forEach((material) => {
                this.tempAttachments[material.id] = [];
                this.tempComments[material.id] = '';
                this.validComment[material.id] = false;
            });
        },
        updateHTML(event, material){
            this.tempComments[material.id] = this.$sanitize(event.target.innerHTML);
            this.validComment[material.id] = (this.tempComments[material.id].trim() !== '');
            this.validComment = Object.assign({}, this.validComment);
        },
        clearMessage(id) {
            this.tempComments[id] = '';
            this.tempAttachments[id] = [];
            this.validComment[id] = false;
            document.getElementById(id).innerText = '';
        },
        async addComment(material){
            const walletConsigneeId = material.id;
            const comment = this.tempComments[walletConsigneeId].trim();
            const data = {
                wallet_consignee_id: walletConsigneeId,
                comment,
            };
            const result = await this.$store.dispatch('walletV2/addComment', { data });
            if (result.data) {
                this.commentId = result.data.id;
                material.comments.push({
                    message: result.data.message,
                    user_name: result.data.user_name,
                    created_at: result.data.created_at,
                    party: result.data.party,
                    id: result.data.id,
                });
                this.tempAttachments[walletConsigneeId].forEach((attachment) => {
                    this.storeAttachment(attachment.file, this.commentId, material);
                });
                this.$emit('updateComment', material.id);
                this.clearMessage(material.id);
            } else if (result.error) {
                this.$errorMessage({ message: result.error });
            }
        },
        async storeAttachment(file, commentId, material) {
            const formData = new FormData();
            formData.append('attachment', file.raw);
            formData.append('parent_id', commentId);
            formData.append('parent_type', attachmentParentType.COMMENT);
            const result = await this.$store.dispatch('walletV2/addAttachment', formData);
            if (result && result.error) {
                this.$errorMessage({ message: result.error });
            } else if( result && result.data) {
                const comment = material.comments.find((comment) => comment.id === commentId);
                if (comment.attachments) {
                    comment.attachments.push(result.data);
                } else {
                    comment.attachments = [result.data];
                }
                material.comments.pop();
                material.comments.push(comment);
            }
        },
        findFileExt(file) {
            if (file.name) {
                const fileName = file.name;
                // eslint-disable-next-line no-bitwise
                return fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
            }
            const fileName = file.url;
            // eslint-disable-next-line no-bitwise
            const index1 = ((fileName.lastIndexOf('.') - 1) >>> 0) + 2;
            let index2 = fileName.indexOf('?');
            index2 = index2 === -1 ? fileName.length : index2;
            return fileName.slice(index1, index2).toLowerCase();
        },
        async removeAttachment(file) {
            const material = this.materials[this.activeId];
            this.tempAttachments[material.id] = this.tempAttachments[material.id].filter( attachment => attachment.uid !== file.uid);
        },
        addAttachment(file, fileList) {
            const isSizeExceed = file.size / 1024 / 1024 < AttachmentConstants.maxMbSize;
            const fileExt = this.findFileExt(file);
            let isFileFormat = AttachmentConstants.images.includes(fileExt) ||
                 AttachmentConstants.pdf.includes(fileExt) ||
                 AttachmentConstants.excel.includes(fileExt);

                     // Check for double extensions
            const fileName = file.name;
            const fileParts = fileName.split('.');
            const hasDoubleExtension = this.checkDoubleExtension(fileParts);

            if (!isSizeExceed) {
                this.$errorMessage({ message: this.$getErr('FILE_SIZE_EXCEED') });
                fileList.pop();
            } else if (!isFileFormat) {
                this.$errorMessage({ message: this.$getErr('INVALID_FORMAT') });
                fileList.pop();
            }  else if (hasDoubleExtension) {
                this.$errorMessage({ message: 'File with multiple extensions not allowed' });
                fileList.pop();
            } else {
                const material = this.materials[this.activeId];
                const data = this.tempAttachments[material.id].concat({
                    url: file.url,
                    name: file.name,
                    status: file.status,
                    uid: file.uid,
                    file,
                });
                Vue.set(this.tempAttachments, material.id, data);
                this.tempAttachments = Object.assign({}, this.tempAttachments);
            }
        },
    },
};

</script>

<style lang="scss">

.comment-box {
  background-color: #F6F9F9;
  padding-top:5px;
  padding-bottom:1px
}

</style>
